import { postRequest } from '../../../shared/utils';

export async function getAllScreenGridFeatures(screenGridId, configSchema) {
  const body = {
    columns: ['value: screen_grid_feature_id', 'label: feature_name'],
    screenGridId,
    schema: configSchema,
    table: 'v_screen_grid_feature',
    key: 'screen_grid_id',
    value: screenGridId,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    return { errors };
  }

  return data;
}
